import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ISettingsScanFlowBehaviorModel } from '@features/settings/scan-flow/shared/models/settings-scan-flow.model';
import { SettingsScanFlowService } from '@features/settings/scan-flow/shared/settings-scan-flow.service';

@Injectable()
export class ScanFlowDisabledGuardService implements CanActivate {
    constructor(
        private settingsScanFlowService: SettingsScanFlowService,
        private router: Router,
    ) { }

    public canActivate(): Observable<boolean> {
        return this.settingsScanFlowService
            .getBehavior()
            .pipe(
                map((response: ISettingsScanFlowBehaviorModel) => {
                    if (!response.scanFlowEnabled) {
                        this.router.navigate(['page-forbidden']);
                    }

                    return response.scanFlowEnabled;
                }));
    }
}
